module.exports = __webpack_public_path__ + "img/18.fddaa16d.png";